// extracted by mini-css-extract-plugin
export default {"root":"content-container_root__sawDB"};